import React, { useCallback } from 'react'
import { Badge, Menu, Switch } from 'antd'
import { getDeleteSessionAction } from '../../store/session/action-creators'
import { DELETE_SESSION_DONE } from '../../store/session/actions'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../hooks/useAppDispatch/useAppDispatch'
import { UserProfileMenuWrapper } from './styles'
import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'
import { useDemoPrivacy } from '../../contexts/demo-privacy-context'

const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData,
)

export const UserProfileMenu = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { sessionData } = useSelector(createSession)
  const pendingModulesCount = Number(sessionData?.pendingModulesCount || 0)
  const { hidePhones, setHidePhones } = useDemoPrivacy()
  const isAdmin = Boolean(sessionData?.roles?.includes(1))

  const handleLogoutClick = useCallback(async () => {
    const lastAction: any = await dispatch(getDeleteSessionAction())
    if (lastAction.type === DELETE_SESSION_DONE) {
      navigate('/')
      return
    }
  }, [dispatch, navigate])

  return (
    <UserProfileMenuWrapper>
      <div
        style={{
          borderBottom: '1px solid #f0f0f0',
        }}
      >
        <div
          style={{
            fontWeight: 600,
            marginBottom: 4,
            padding: '0 16px 4px',
          }}
        >
          {sessionData.user.name || sessionData.user.login}
        </div>
      </div>
      <Menu style={{ borderRight: 'none' }}>
        <Menu.Item key="profile/">
          <span>Настройки профиля</span>
        </Menu.Item>
        <Menu.Item key="profile-card/">
          <span>Карточка участника</span>
        </Menu.Item>
        {isAdmin && (
          <>
            <Menu.Divider />
            <Menu.Item
              key="demo-hide-phones"
              onClick={e => {
                e.domEvent?.stopPropagation?.()
                e.domEvent?.preventDefault?.()
              }}
            >
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 12,
                  width: '100%',
                }}
                onClick={e => e.stopPropagation()}
              >
                Скрыть номера телефонов
                <Switch size="small" checked={hidePhones} onChange={setHidePhones} />
              </span>
            </Menu.Item>
          </>
        )}
        <Menu.Divider />
        <Menu.Item key="/settings/modules" onClick={() => navigate('/settings/modules')}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            Модули и подписка
            {pendingModulesCount > 0 && <Badge count={pendingModulesCount} size="small" />}
          </span>
        </Menu.Item>
        <Menu.Item key="/billing" onClick={() => navigate('/billing')}>
          <span>Биллинг</span>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key="/logout/" onClick={handleLogoutClick}>
          <span>Выход</span>
        </Menu.Item>
      </Menu>
    </UserProfileMenuWrapper>
  )
}
